<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
    scrollable
  >
    <v-card class="pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent>
          <!-- eslint-disable -->
          <v-radio-group
            v-model="autoShare"
            class="colored-options"
            data-testid="choose-sharing-options"
          >
            <v-radio
              key="enable"
              label="1"
              :value="true"
              color="accent"
              class="black--text pa-5 option rounded-xxl mb-4"
              data-testid="auto-sharing-enabled"
              active-class="selected"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{ $t('confirmationDialogActivityAutosharingOption1Title') }}</span
                  ><br />
                  <span 
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{ $t('confirmationDialogActivityAutosharingOption1Text') }}
                  </span>
                  <br />
                </div>
              </template>
            </v-radio>
            <v-radio
              key="disable"
              label="2"
              :value="false"
              color="accent"
              class="black--text pa-5 option rounded-xxl mb-4"
              data-testid="auto-sharing-disabled"
              active-class="selected"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{ $t('confirmationDialogActivityAutosharingOption2Title') }}</span
                  ><br />
                  <span 
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{ $t('confirmationDialogActivityAutosharingOption2Text') }}
                  </span>
                  <br />
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show = false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="submitDialogBtn()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
export default {
  components: {
  },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t("submit"),
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t("cancel"),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activityAutoShare: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      valid: true,
      valAutoShare: false
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
          this.$refs.form.reset();
        }
      },
    },
    autoShare:
      {
        get()
        {
            return this.valAutoShare
        },
        set(activityAutoShare)
        {
            this.valAutoShare = activityAutoShare
        }
      },
    },
  watch: {
      activityAutoShare(newValAutoShare) {
          this.valAutoShare = newValAutoShare
      },
  },

  async created() {
    this.autoShare = this.activityAutoShare
  },
  methods: {
    submitDialogBtn() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.$emit("proceedSubmit", this.autoShare);
      }
    }
  },
};
</script>